// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AppReviewAskController from "./app_review_ask_controller"
application.register("app-review-ask", AppReviewAskController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import BottomSheetController from "./bottom_sheet_controller"
application.register("bottom-sheet", BottomSheetController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColorToggleController from "./color_toggle_controller"
application.register("color-toggle", ColorToggleController)

import ConfettiController from "./confetti_controller"
application.register("confetti", ConfettiController)

import ContentsTypeController from "./contents_type_controller"
application.register("contents-type", ContentsTypeController)

import CookLaunchController from "./cook_launch_controller"
application.register("cook-launch", CookLaunchController)

import CookbookCollectController from "./cookbook_collect_controller"
application.register("cookbook-collect", CookbookCollectController)

import CookbookFontsController from "./cookbook_fonts_controller"
application.register("cookbook-fonts", CookbookFontsController)

import CookingModeController from "./cooking_mode_controller"
application.register("cooking-mode", CookingModeController)

import CookVoiceController from "./cook_voice_controller"
application.register("cook-voice", CookVoiceController)

import CookingTimerController from "./cooking_timer_controller"
application.register("cooking-timer", CookingTimerController)

import CoverDragController from "./cover_drag_controller"
application.register("cover-drag", CoverDragController)

import CoverEditorController from "./cover_editor_controller"
application.register("cover-editor", CoverEditorController)

import CoverPlateController from "./cover_plate_controller"
application.register("cover-plate", CoverPlateController)

import CoverStyleController from "./cover_style_controller"
application.register("cover-style", CoverStyleController)

import DarkModeController from "./dark_mode_controller"
application.register("dark-mode", DarkModeController)

import DashboardFilterController from "./dashboard_filter_controller"
application.register("dashboard-filter", DashboardFilterController)

import DayPickerController from "./day_picker_controller"
application.register("day-picker", DayPickerController)

import DeleteConfirmController from "./delete_confirm_controller"
application.register("delete-confirm", DeleteConfirmController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DiscoverController from "./discover_controller"
application.register("discover", DiscoverController)

import DragScrollController from "./drag_scroll_controller"
application.register("drag-scroll", DragScrollController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ExpandableTextController from "./expandable_text_controller"
application.register("expandable-text", ExpandableTextController)

import FavoriteController from "./favorite_controller"
application.register("favorite", FavoriteController)

import FindChefsModalController from "./find_chefs_modal_controller"
application.register("find-chefs-modal", FindChefsModalController)

import FormErrorsController from "./form_errors_controller"
application.register("form-errors", FormErrorsController)

import FormProgressController from "./form_progress_controller"
application.register("form-progress", FormProgressController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import FreshFrameController from "./fresh_frame_controller"
application.register("fresh-frame", FreshFrameController)

import GroceryAddController from "./grocery_add_controller"
application.register("grocery-add", GroceryAddController)

import GroceryBulkController from "./grocery_bulk_controller"
application.register("grocery-bulk", GroceryBulkController)

import GroceryItemController from "./grocery_item_controller"
application.register("grocery-item", GroceryItemController)

import GroceryPreviewController from "./grocery_preview_controller"
application.register("grocery-preview", GroceryPreviewController)

import GrocerySelectController from "./grocery_select_controller"
application.register("grocery-select", GrocerySelectController)

import GrocerySelectionController from "./grocery_selection_controller"
application.register("grocery-selection", GrocerySelectionController)

import HelpController from "./help_controller"
application.register("help", HelpController)

import ImportTabsController from "./import_tabs_controller"
application.register("import-tabs", ImportTabsController)

import SharedImportController from "./shared_import_controller"
application.register("shared-import", SharedImportController)

import IngredientCheckboxController from "./ingredient_checkbox_controller"
application.register("ingredient-checkbox", IngredientCheckboxController)

import KeyboardShortcutsController from "./keyboard_shortcuts_controller"
application.register("keyboard-shortcuts", KeyboardShortcutsController)

import KitchenSearchModalController from "./kitchen_search_modal_controller"
application.register("kitchen-search-modal", KitchenSearchModalController)

import KitchenWelcomeModalSaveController from "./kitchen_welcome_modal_save_controller"
application.register("kitchen-welcome-modal-save", KitchenWelcomeModalSaveController)

import KitchenWelcomeModalToggleController from "./kitchen_welcome_modal_toggle_controller"
application.register("kitchen-welcome-modal-toggle", KitchenWelcomeModalToggleController)

import LazyFrameController from "./lazy_frame_controller"
application.register("lazy-frame", LazyFrameController)


import LocalDataController from "./local_data_controller"
application.register("local-data", LocalDataController)

import MatchSliderController from "./match_slider_controller"
application.register("match-slider", MatchSliderController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultiPhotoController from "./multi_photo_controller"
application.register("multi-photo", MultiPhotoController)

import NestedFieldsController from "./nested_fields_controller"
application.register("nested-fields", NestedFieldsController)

import OfflineGroceryController from "./offline_grocery_controller"
application.register("offline-grocery", OfflineGroceryController)

import OfflineTileController from "./offline_tile_controller"
application.register("offline-tile", OfflineTileController)

import OfflinePrewarmController from "./offline_prewarm_controller"
application.register("offline-prewarm", OfflinePrewarmController)

import PantryBulkController from "./pantry_bulk_controller"
application.register("pantry-bulk", PantryBulkController)

import PantryRemoveController from "./pantry_remove_controller"
application.register("pantry-remove", PantryRemoveController)

import PantryScanFormController from "./pantry_scan_form_controller"
application.register("pantry-scan-form", PantryScanFormController)

import ParallaxController from "./parallax_controller"
application.register("parallax", ParallaxController)

import PhotoDropController from "./photo_drop_controller"
application.register("photo-drop", PhotoDropController)

import PhotoEditController from "./photo_edit_controller"
application.register("photo-edit", PhotoEditController)

import PhotoSortController from "./photo_sort_controller"
application.register("photo-sort", PhotoSortController)

import PhotoZoomController from "./photo_zoom_controller"
application.register("photo-zoom", PhotoZoomController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import PwaInstallController from "./pwa_install_controller"
application.register("pwa-install", PwaInstallController)

import QuickMealController from "./quick_meal_controller"
application.register("quick-meal", QuickMealController)

import QuickMealIngredientsController from "./quick_meal_ingredients_controller"
application.register("quick-meal-ingredients", QuickMealIngredientsController)

import QuickPlanController from "./quick_plan_controller"
application.register("quick-plan", QuickPlanController)

import RecipeInstacartController from "./recipe_instacart_controller"
application.register("recipe-instacart", RecipeInstacartController)

import RecipePickerController from "./recipe_picker_controller"
application.register("recipe-picker", RecipePickerController)

import RecipeSwipeController from "./recipe_swipe_controller"
application.register("recipe-swipe", RecipeSwipeController)

import RecipeTypeController from "./recipe_type_controller"
application.register("recipe-type", RecipeTypeController)

import ReportController from "./report_controller"
application.register("report", ReportController)

import RippleController from "./ripple_controller"
application.register("ripple", RippleController)

import ScanPollController from "./scan_poll_controller"
application.register("scan-poll", ScanPollController)

import ScanSubmitController from "./scan_submit_controller"
application.register("scan-submit", ScanSubmitController)

import ScanTypeToggleController from "./scan_type_toggle_controller"
application.register("scan-type-toggle", ScanTypeToggleController)

import ScreenWakeLockController from "./screen_wake_lock_controller"
application.register("screen-wake-lock", ScreenWakeLockController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SearchToggleController from "./search_toggle_controller"
application.register("search-toggle", SearchToggleController)

import ServingsScalerController from "./servings_scaler_controller"
application.register("servings-scaler", ServingsScalerController)

import ShareCardController from "./share_card_controller"
application.register("share-card", ShareCardController)

import ShareLinkController from "./share_link_controller"
application.register("share-link", ShareLinkController)

import SharingToggleController from "./sharing_toggle_controller"
application.register("sharing-toggle", SharingToggleController)

import SheetTriggerController from "./sheet_trigger_controller"
application.register("sheet-trigger", SheetTriggerController)

import ShopChooserController from "./shop_chooser_controller"
application.register("shop-chooser", ShopChooserController)

import SkeletonController from "./skeleton_controller"
application.register("skeleton", SkeletonController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import StepperController from "./stepper_controller"
application.register("stepper", StepperController)

import SwipeDeleteController from "./swipe_delete_controller"
application.register("swipe-delete", SwipeDeleteController)

import TagSelectController from "./tag_select_controller"
application.register("tag-select", TagSelectController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TransientModalController from "./transient_modal_controller"
application.register("transient-modal", TransientModalController)

import ViewMenuController from "./view_menu_controller"
application.register("view-menu", ViewMenuController)

import ViewToggleController from "./view_toggle_controller"
application.register("view-toggle", ViewToggleController)

import WeekNavigationController from "./week_navigation_controller"
application.register("week-navigation", WeekNavigationController)

